const fields = [
  {
    dataIndex: 'patentName',
    key: 'patentName',
    title: '专利名称',
    width: 180,
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'operationTypeStr',
    key: 'operationTypeStr',
    title: '运营类型',
    width: 80
  },
  {
    dataIndex: 'statusStr',
    key: 'statusStr',
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '创建时间'
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 150,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 8,
    label: '专利名称',
    component: 'AInput',
    placeholder: '请输入专利名称',
    prop: 'patentName',
    allowClear: true
  },
  {
    span: 8,
    label: '运营类型',
    component: 'ASelect',
    placeholder: '请输入需求名称',
    prop: 'operationType',
    allowClear: true,
    list: [
      // { label: '待转化', value: 0 },
      { label: '许可', value: 1 },
      { label: '质押', value: 2 },
      { label: '转让', value: 3 },
      { label: '免费许可', value: 4 }
    ]
  },
  {
    span: 8,
    label: '创建日期',
    component: 'ASelect',
    prop: 'searchValue',
    placeholder: '选择创建日期',
    list: [
      { label: '全部时间', value: 0 },
      { label: '一个月', value: 1 },
      { label: '三个月', value: 2 },
      { label: '半年', value: 3 },
      { label: '一年', value: 4 }
    ]
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: []
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}
